var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pui-header-button-separator pui-header-button-separator__root"},[_c('span',{staticClass:"pui-header-button-separator__separator"})])
}]

export { render, staticRenderFns }